import Vue from 'vue'
import Router from 'vue-router'

import Base from 'layout/Base.vue'
import Home from 'views/Home.vue'
import Menu from 'views/Menu.vue'
import Mission from 'views/Mission.vue'
import Contact from 'views/Contact.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/fr',
      component: Base,
      children: [
        {
          path: '',
          name: 'home',
          component: Home
        },
        {
          path: 'menu',
          name: 'menu',
          component: Menu
        },
        {
          path: 'mission',
          name: 'mission',
          component: Mission
        },
        {
          path: 'contact',
          name: 'contact',
          component: Contact
        }
      ]
    },
    {
      path: '*',
      redirect: '/fr'
    }
  ],
  linkActiveClass: 'is-active',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// Add body classes
router.afterEach((to, from) => {
  document.body.classList.remove(`p-${from.name}`)
  document.body.classList.add(`p-${to.name}`)
})

export default router
